import React, { useEffect, useState, FC } from 'react';
import * as pdfjsLib from 'pdfjs-dist';
import { Loader } from '../../ui-library';

// Set worker source using the version from the library
pdfjsLib.GlobalWorkerOptions.workerSrc = `//unpkg.com/pdfjs-dist@${pdfjsLib.version}/build/pdf.worker.min.mjs`;

interface PdfFirstPageToPngProps {
    /** The URL or path to the PDF file */
    pdfUrl: string;
}

const PdfFirstPageToPng: FC<PdfFirstPageToPngProps> = ({ pdfUrl }) => {
    const [imageSrc, setImageSrc] = useState<string | null>(null);

    useEffect(() => {
        let isMounted = true;

        const loadPdf = async () => {
            try {
                const loadingTask = pdfjsLib.getDocument(pdfUrl);
                const pdf = await loadingTask.promise;
                const page = await pdf.getPage(1);

                const viewport = page.getViewport({ scale: 2.0 });
                const canvas = document.createElement('canvas');
                const context = canvas.getContext('2d');

                if (!context) {
                    throw new Error('Could not create canvas context');
                }

                canvas.width = viewport.width;
                canvas.height = viewport.height;

                const renderContext: any = {
                    canvasContext: context,
                    viewport,
                };

                await page.render(renderContext).promise;

                if (isMounted) {
                    const pngDataUrl = canvas.toDataURL('image/png');

                    setImageSrc(pngDataUrl);
                }
            } catch (err) {
                console.error('Error rendering PDF:', err);
            }
        };

        loadPdf();

        return () => {
            isMounted = false;
        };
    }, [pdfUrl]);

    return (
        <div className="pdf-first-page-to-png">
            {imageSrc ? (
                <img
                    src={imageSrc}
                    alt="First page of PDF as PNG"
                    style={{ maxWidth: '100%', height: 'auto' }}
                />
            ) : (
                <Loader />
            )}
        </div>
    );
};

export default PdfFirstPageToPng;
